import { AssistantCatHomeAction } from "@/constants/assistantCatHome";
import { NolaItemId } from "@/lib/utils/analytics";

export function assistantCatHomeMenuItemId(action: AssistantCatHomeAction): NolaItemId {
  switch (action) {
    case "feedbackManuscript":
      return NolaItemId.AssistantCatHomeMenuFeedback;
    case "generateSummary":
      return NolaItemId.AssistantCatHomeMenuSummary;
    case "catchcopy":
      return NolaItemId.AssistantCatHomeMenuCatchcopy;
    case "matchingNovelAndCompany":
      return NolaItemId.AssistantCatHomeMenuMatching;
    case "feedbackTheme":
      return NolaItemId.AssistantCatHomeMenuThemeFeedback;
    case "matchingTheme":
      return NolaItemId.AssistantCatHomeMenuThemeMatching;
    case "generateTheme":
      return NolaItemId.AssistantCatHomeMenuThemeGenerate;
    case "changeAssistantCat":
      return NolaItemId.AssistantCatHomeMenuChangeCat;
    case "changeNickname":
      return NolaItemId.AssistantCatHomeMenuChangeNickname;
    case "changeFeedbackMode":
      return NolaItemId.AssistantCatHomeMenuFeedbackMode;
    case "changeSummaryMode":
      return NolaItemId.AssistantCatHomeMenuSummaryMode;
    case "fishHistory":
      return NolaItemId.AssistantCatHomeMenuFishHistory;
    case "paymentManage":
      return NolaItemId.AssistantCatHomeMenuPayment;
    default:
      return NolaItemId.AssistantCatHomeMenuFeedback;
  }
}
